// src/extensions/SanitizeHtml.ts
import { Extension } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'
import sanitizeHtml from 'sanitize-html'

export const SanitizeHtml = Extension.create({
  name: 'pasteFromWord',

  addOptions() {
    return {
      sanitizeOptions: {
        allowedTags: [
          'h1','h2','h3','h4','h5','h6',
          'p','blockquote','pre','code',
          'ul','ol','li',
          'table','thead','tbody','tr','th','td',
          'a','strong','em','b','i','u','img',
          'span',
        ],
        allowedAttributes: {
          a:    ['href','target','rel'],
          img:  ['src','alt','title','width','height'],
          table:['border','cellpadding','cellspacing'],
          th:   ['colspan','rowspan','align'],
          td:   ['colspan','rowspan','align'],
          span: ['style'],
          div:  ['style'],
        },
        allowedStyles: {
          '*': {
            // basic text formatting
            'color':       [/^#(?:[0-9A-Fa-f]{3}){1,2}$/,  /^rgb\(\d+,\s*\d+,\s*\d+\)$/],
            'font-size':   [/^\d+(?:pt|px)$/],
            'font-family': [/.+/],      // you could tighten this up
            'font-weight': [/^(?:normal|bold|\d{3})$/],
            'font-style':  [/^(?:normal|italic)$/],
            'text-decoration': [/^(?:underline|line-through)$/],
            'text-transform': [/.+/],

            // alignment and spacing
            'text-align':  [/^(?:left|right|center|justify)$/],
            'margin-left': [/^\d+(?:pt|px)$/], 
            'margin-right':[/^\d+(?:pt|px)$/],

            // background or highlighting
            'background-color': [/^#(?:[0-9A-Fa-f]{3}){1,2}$/],

            // allow border shorthand
            'border':        [/.+/],

            // or individually if you prefer:
            'border-style':  [/^(?:none|solid|dashed|dotted|double)$/],
            'border-width':  [/^\d+(?:px|pt)$/],
            'border-color':  [/^#(?:[0-9A-Fa-f]{3}){1,2}$/, /^[a-z]+$/],

            // table‑specific
            'border-collapse': [/^(?:collapse|separate)$/],
          },
        },

        // everything else stays the same…
        allowedSchemes: ['http','https','mailto','tel','data'],
        allowedSchemesByTag: { img: ['http','https','data', 'src'] },
        exclusiveFilter: (frame: { tag: string; text: string; attribs: { style: any }; element: { children: string | any[] } }) => {
          // only target spans & ps
          if (frame.tag === 'span' || frame.tag === 'p') {
            let raw = frame.text || ''
            // 2) strip out NBSPs and zero‑width spaces
            raw = raw.replace(/[\u00A0\u200B\uFEFF]/g, '')
            const textEmpty = raw.trim() === ''

            if (textEmpty) {
              return true
            }
          }
          return false
        },
        nonTextTags: ['script','style','textarea','noscript'],
      },
    }
  },

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          transformPastedHTML: (html: string) => {
            let cleaned = sanitizeHtml(html, this.options.sanitizeOptions)
            return cleaned.trim()
          },
        }
      }),
    ]
  },

  addStorage() {
    return {
      sanitize: (html: string) =>
        sanitizeHtml(html, this.options.sanitizeOptions).trim(),
    }
  }
})
